import DataAccess from './constants';
import API from './API'

const path = 'orderlocations';
let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const getOrderLocationsByDisplayArea = (displayArea) => {
    let newpath = path + "?displayArea=" + displayArea;
    return api.getData(newpath)
}